import { edited } from "../actions";

const editBooks = (id, name, author, thumbnail, price, rating, featured) => {
  return async (dispatch) => {
    const response = await fetch(`http://localhost:9000/books/${id}`, {
      method: "PATCH",
      body: JSON.stringify({
        name,
        author,
        thumbnail,
        price,
        rating,
        featured,
      }),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    });
    const book = await response.json();
    dispatch(
      edited(
        id,
        book.name,
        book.author,
        book.thumbnail,
        book.price,
        book.rating,
        book.featured
      )
    );
  };
};
export default editBooks;
